export const articlesStudents = [
  {
    articleId: 'awardsundergrad',
    bubbleTextOne: 'Undergraduate',
    bubbleTextTwo: 'Student',
    bubbleTextThree: 'Awards',
    articleHeadlineOne:'ECE Student Awards 2022-2023',
    articleHeadlineTwo:'Bachelor of Science Awards',
    articleHeadlineThree: 'and Christina Huang Memorial Prize',
    articleCallout1: '',
    articleCallout2: '',
    articleImage1: '',
    articleImage2: '',
    articleImage3: '',
    articleImage4: '',
    articleImage5: '',
    articleImage6: '',
    articleImageAltText1: '',
    articleImageAltText2: '',
    articleImageAltText3: '',
    articleImageAltText4: '',
    articleImageAltText5: '',
    articleImageAltText6: '',
    articleImageMain: '/2022-2023/img/observatory-venti-views_tiMC85fY.jpg',
    articleImageAltTextMain: 'UCLA building with shadow',
    articleImageProf: '/2022-2023/img/student-Isha-Gonugunta.jpg',
    articleImageAltTextProf: 'UCLA Students Isha Gonugunta',
    articleImageCred: 'top photo by Unsplash',
    articleCaption1: '',
    articleCaption2: '',
    articleCaption3: '',
    articleAuthor: '',
    textCopy: '<div class="grid-cards"><div class="card-students"><div class="card"><div class="prof-name">Isha Gonugunta</div><div class="prof-title">Christina Huang Memorial Prize</div><div class="student-frame"><img src="/2022-2023/img/student-Isha-Gonugunta.jpg"></div></div><div class="card"><div class="prof-name">Jason Wu</div><div class="prof-title">Outstanding Bachelor of Science Award in Electrical Engineering</div><div class="student-frame"><img src="/2022-2023/img/student-Jason-Wu.jpg"></div></div><div class="card"><div class="prof-name">Bradley Schulz</div><div class="prof-title">Outstanding Bachelor of Science Award in Computer Engineering</div><div class="student-frame"><img src="/2022-2023/img/student-Bradley-Schulz.jpg"></div></div></div><div class="spacer"><img src="/img/pixel.png"></div></div>',
  },
  {
    articleId: 'awardsgrad',
    bubbleTextOne: ' Graduate  ',
    bubbleTextTwo: ' Students',
    bubbleTextThree: 'Awards',
    articleHeadlineOne:'ECE Student Awards 2022-2023',
    articleHeadlineTwo:'Graduate Students Awards',
    articleHeadlineThree: 'Masters and Ph.D. ',
    articleCallout1: '',
    articleCallout2: '',
    articleImage1: '',
    articleImage2: '',
    articleImage3: '',
    articleImage4: '',
    articleImage5: '',
    articleImage6: "",
    articleImageAltText1: '',
    articleImageAltText2: '',
    articleImageAltText3: '',
    articleImageAltText4: '',
    articleImageAltText5: '',
    articleImageAltText6: '',
    articleImageMain: '/2022-2023/img/disney-hall-linda-pomerantz-zhang-XOeCBcX42s4.jpg',
    articleImageAltTextMain: 'Disney Concert Hall in Los Angeles',
    articleImageProf: '/2022-2023/img/student-Adnan-Al-Armouti.jpg',
    articleImageAltTextProf: 'UCLA Students Adnan Al Armouti',
    articleImageCred: 'top photo by Unsplash',
    articleCaption1: '',
    articleCaption2: '',
    articleCaption3: '',
    articleAuthor: '',
    textCopy: '   <div class="grid-cards"><div class="card-students"><div class="card"><div class="card-title">Distinguished Master’s Thesis Research Award</div><div class="prof-name">Adnan Al Armouti</div><div class="prof-area">Signals & Systems</div><div class="prof-title">Fusing Light and Radio Signals for More<br>Accurate and Equitable Blood Flow Estimation”</div><div class="card-advisor">Advisor: Professor Achuta Kadambi</div><div class="student-frame"><img src="/2022-2023/img/student-Adnan-Al-Armouti.jpg"></div></div></div><div class="grid-cards"><div class="card-students"><div class="card"><div class="card-title">Distinguished Ph.D. Dissertation</div><div class="prof-area">Circuits & Embedded Systems</div><div class="prof-name">Wojciech Romaszkan</div><div class="prof-title"><i>Efficient Machine Learning<br>Acceleration at the Edge</i></div><div class="card-advisor">Advisor: Prof. Puneet Gupta</div><div class="student-frame"><img src="/2022-2023/img/student-Wojciech-Romaszkan.jpg"></div></div><div class="card"><div class="card-title">Distinguished Ph.D. Dissertation</div><div class="prof-area">Physical & Wave Electronics</div><div class="prof-name">Junbo Wang</div><div class="prof-title"><i>Beam Steerable Antennas for CubeSats:<br>Novel Synthesis Methods and Implementations of Reflectarrays and Transmitarrays</i></div><div class="card-advisor">Advisor: Professor Yahya Rahmat-Samii</div><div class="student-frame"><img src="/2022-2023/img/student-Junbo-Wang.jpg"></div></div><div class="card"><div class="card-title">Distinguished Ph.D. Dissertation</div><div class="prof-area">Signals & Systems</div><div class="prof-name">Antonious M. Girgis</div><div class="prof-title"><i>Communication-Efficient and Private<br>Distributed learning</i></div><div class="card-advisor">Advisor: Professor Suhas Diggavi</div><div class="student-frame"><img src="/2022-2023/img/student-Antonious-Girgis.jpg"></div></div></div></div><div class="spacer"><img src="/img/pixel.png"></div></div>  '
  },

  {
    articleId: 'awardsteaching',
    bubbleTextOne: 'Teaching ',
    bubbleTextTwo: ' Awards',
    bubbleTextThree: '',
    articleHeadlineOne:'ECE Teaching Awards 2022-2023',
    articleHeadlineTwo:'Samueli Excellence in Teaching Award Recipients',
    articleHeadlineThree: '',
    articleCallout1: '',
    articleCallout2: '',
    articleImage1: '',
    articleImage2: '',
    articleImage3: '',
    articleImage4: '',
    articleImage5: '',
    articleImage6: '',
    articleImageAltText1: '',
    articleImageAltText2: '',
    articleImageAltText3: '',
    articleImageAltText4: '',
    articleImageAltText5: '',
    articleImageAltText6: '',
    articleImageMain: '/2022-2023/img/gamer-rawpixel-12200372.jpg',
    articleImageAltTextMain: 'Cityscape with graphics over skyline',
    articleImageProf: '/2022-2023/img/student-Eilam-Morag.jpg',
    articleImageAltTextProf: 'UCLA Students and Teaching Awards  ',
    articleImageCred: 'photo by Rawpixel ',
    articleCaption1: ' ',
    articleCaption2: '',
    articleCaption3: '',
    articleAuthor: '',
    textCopy: '<div class="grid-cards"><div class="card-students"><div class="card"><div class="prof-name">Eilam Morag</div><div class="student-frame"><img src="/2022-2023/img/student-Eilam-Morag.jpg"></div></div><div class="card"><div class="prof-name">Rakshith Ravindra Gore</div><div class="student-frame"><img src="/2022-2023/img/student-Rakshith-Gore.jpg"></div></div><div class="card"><div class="prof-name">Talha Yerebakan</div><div class="student-frame"><img src="/2022-2023/img/student-Yerebakan-Talha.jpg"></div></div></div></div>'
  },
  {
    articleId: 'hkn',
    bubbleTextOne: 'Student',
    bubbleTextTwo: ' Centers',
    bubbleTextThree: 'UCLA HKN',
    articleHeadlineOne:'ECE \'s Student Centers ',
    articleHeadlineTwo:'UCLA HKN',
    articleHeadlineThree: '',
    articleCallout1: '',
    articleCallout2: '',
    articleImage1: '',
    articleImage2: '',
    articleImage3: '',
    articleImage4: '',
    articleImage5: '',
    articleImage6: '',
    articleImageAltText1: '',
    articleImageAltText2: '',
    articleImageAltText3: '',
    articleImageAltText4: '',
    articleImageAltText5: '',
    articleImageAltText6: '',
    articleImageMain: '/2022-2023/img/cityscape-graphic-skyline_MFA.jpg',
    articleImageAltTextMain: 'Cityscape with graphic skyline',
    articleImageProf: '/2022-2023/img/ieee_hkn2_oustandingChapter.jpg',
    articleImageAltTextProf: 'UCLA Students HKN Oustanding Chapter',
    articleImageCred: '',
    articleCaption1: '',
    articleCaption2: '',
    articleCaption3: '',
    articleAuthor: 'by Erica Xie',
    textCopy: '  <div class="grid-layout"><div class="student-center-frame"><img src="/img/hkn-logo.png"></div><div class="page-text"><p style="text-indent: 0;"> <span class="first-letter"> The UCLA</span> Iota Gamma Chapter of Eta Kappa Nu (HKN) is the electrical and computer engineering honor society dedicated to encouraging excellence through scholarship, service, leadership, and character. The Iota Gamma Chapter currently has around 150 members and continues to grow. HKN aims to serve the ECE community under the guidance of Professor Benjamin Williams, providing tutoring and hosting various events throughout the year.</p><p>The events are split into technical events and social events. The technical events include a quarterly professor lunch, corporate infosessions, and our workshop series on MATLAB and Verilog. The social events ­include board game nights, movie nights, and KBBQ outings. One of the main events that HKN co-hosts with the IEEE branch is the annual ECE Department Town Hall, where students can provide feedback on the ­current curriculum.</p></div><div class="student-center-frame"><img src="/img/hkn.jpg"><br></div><div class="spacer"><img src="/img/pixel.png"></div> '
  },
  {
    articleId: 'ieee',
    bubbleTextOne: 'Student',
    bubbleTextTwo: ' Centers',
    bubbleTextThree: 'UCLA IEEE',
    articleHeadlineOne:'ECE \'s Student Centers ',
    articleHeadlineTwo:'UCLA IEEE Student Chapter',
    articleHeadlineThree: '',
    articleCallout1: '',
    articleCallout2: '',
    articleImage1: '/2022-2023/img/ieee2.jpg',
    articleImage2: '/2022-2023/img/ieee3.jpg',
    articleImage3: '',
    articleImage4: '',
    articleImage5: '',
    articleImage6: '',
    articleImageAltText1: ' ',
    articleImageAltText2: '',
    articleImageAltText3: '',
    articleImageAltText4: '',
    articleImageAltText5: '',
    articleImageAltText6: '',
    articleImageMain: '/2022-2023/img/soldering-board-onbmuAxvmwM.jpg',
    articleImageAltTextMain: 'UCLA Campus ieee students arms with ieee logo tattoo',
    articleImageProf: '/2022-2023/img/ieee1.jpg',
    articleImageAltTextProf: 'UCLA Students Center IEEE',
    articleImageCred: 'Getty Images. ',
    articleCaption1: 'UCLA IEEE student center events',
    articleCaption2: '',
    articleCaption3: '',
    articleAuthor: 'Erica Xie',
    textCopy: ' <div class="grid-layout"> <div class="page-text"> <p style="text-indent: 0;"> <span class="first-letter"> IEEE at UCLA</span> is a professional student-run organization dedicated to providing a space where engineers of all backgrounds can come together, collaborate, and learn. Every year, IEEE at UCLA hosts over 100 events, encompassing technical lectures, community outreach, professional development, socials, industry workshops, and IDEA Hacks, one of the largest hardware hackathons in the nation. Additionally, we lead several projects for our members to participate in, where dedicated leads provide fundamental knowledge and skills to students to help them complete challenging and interesting projects. Currently, members can choose between 5 diverse projects: <span>OPS, Micromouse, Aircopter, DAV,</span> and <span>WRAP.</span> Additionally, we hold workshops throughout the year that members are free to drop in on and attend. </p><p> Our <span>OPS</span> program is designed to provide hands-on foundational knowledge in the field of tech and hardware. We assume you know absolutely nothing, and build your knowledge from the ground up. Throughout the year, students will be challenged to complete 3-4 small projects per quarter by applying the skills they have learned. </p><p> A <span> micromouse</span> is a small robot that is programmed to find its way to a goal within a maze. In this program, our leads teach you the fundamentals of how a micromouse is designed, and eventually you will print your own PCB, solder a micromouse together, and program it through a maze. We hold annual events where students are invited to compete against each other with their micromouses. </p><p> Our <span>Aircopter </span>program is designed around a few projects that require more advanced topics not covered in our beginning OPS program. Some of the subjects we emphasize in this program are communication, advanced control, motors, and common modules such as gyroscopes and radio modules to build a quadcopter. </p><p>The <span>Digital Audio Visualizer</span> project, or <span>DAV,</span> is designed to give students a new learning experience with hardware design for digital logic circuits. Students will build a real-life application of signal processing by using an FPGA to calculate Fourier Transforms from microphone audio, and displaying the frequency information on a monitor. </p><p> The <span>Wireless, RF, and Analog Project,</span> or <span>WRAP,</span> is an opportunity for students to dive into analog circuits and wireless communications, beyond what is covered in classes. Over the course of the school year, students will learn the fundamentals of analog and RF circuits, and digital communications. Using this knowledge, students will design, simulate, and fabricate from scratch their own wireless transmitter and receiver system. </p><p> IEEE also holds a series of workshops throughout the school year where anyone can participate and learn about new skills and technologies. These workshops are aimed at teaching everyone about common skills in electrical engineering such as soldering, image processing, prototyping, and electronics. For more information, please visit our website at <a class="link" target="_blank" rel="noopener" href="http://ieeebruins.com/"> <i>http://ieeebruins.com/. </i> </a></p> '
  },
  {
    articleId: 'watt',
    bubbleTextOne: 'Student',
    bubbleTextTwo: ' Centers',
    bubbleTextThree: 'WATT',
    articleHeadlineOne:'ECE \'s Student Centers ',
    articleHeadlineTwo:'UCLA WATT - Women Advancing Tech through Teamwork',
    articleHeadlineThree: '',
    articleCallout1: '',
    articleCallout2: '',
    articleImage1: '',
    articleImage2: '',
    articleImage3: '',
    articleImage4: '',
    articleImage5: '',
    articleImage6: '',
    articleImageAltText1: 'student centers',
    articleImageAltText2: '',
    articleImageAltText3: '',
    articleImageAltText4: '',
    articleImageAltText5: '',
    articleImageAltText6: '',
    articleImageMain: '/2022-2023/img/circuit-board-vishnu-mohanan-pfR18JNEMv8.jpg',
    articleImageAltTextMain: 'computer circuit board',
    articleImageProf: '/2022-2023/img/ece-watt.png',
    articleImageAltTextProf: 'UCLA Students',
    articleImageCred: 'photo by Vishnu Mohanan. ',
    articleCaption1: 'Student centers',
    articleCaption2: '',
    articleCaption3: '',
    articleAuthor: '',
    textCopy: '  <div class="grid-layout"><div class="page-text"><p style="text-indent: 0;"> <span class="first-letter"> IEEE WATT </span>  (Women Advancing Tech through Teamwork) is a technical advocacy group for women and minorities in Electrical Engineering, operating as a branch of IEEE. We empower both students at UCLA and younger girls in our community.</p><p>Throughout the year, WATT hosts a number of social, outreach, technical, mental health/advocacy, and professional workshops. We partner with K-12 schools in LA county to teach electrical engineering and programming courses, host 2-3 quarterly technical workshops for UCLA students, promote mental health and wellness through partnerships with other UCLA organizations, and invite company sponsors for info sessions/recruiting events. Additionally, WATT has a mentorship program, HogWATTs, in which we partner students one on one in order to help new incoming students get acclimated at UCLA. For more information, check us out at <span><a target="_blank" rel="noopener" href="http://www.ieeewatt.ucla.edu">http://www.ieeewatt.ucla.edu</a></span>.</p><p></p><div class="grid-cards"><div class="student-center-frame"><img src="/2022-2023/img/ece-watt1.jpg"></div><div class="student-center-frame"><img src="/2022-2023/img/ece-watt2.jpg"></div></div></div></div>    '
  }
];
